
export enum AvoltaAlarmKeyEnum {
    CH4_concentration_alarm = 'CH4_concentration_alarm',
    CH4_sensor_error_alarm = 'CH4_sensor_error_alarm',
    CH4_temperature_alarm = 'CH4_temperature_alarm',
    CH4_battery_alarm = 'CH4_battery_alarm',
    CH4_ndir_fatal_alarm = 'CH4_ndir_fatal_alarm',
    CH4_ndir_intermittent_alarm = 'CH4_ndir_intermittent_alarm',
    CH4_ndir_communication_alarm = 'CH4_ndir_communication_alarm',
    CH4_env_out_of_range_alarm = 'CH4_env_out_of_range_alarm',
    CH4_internal_alarm = 'CH4_internal_alarm',
    CH4_eol_alarm = 'CH4_eol_alarm',
}

export enum AvoltaAlarmEnum {
    CH4_concentration_alarm = 'CH4_concentration_alarm',
    CH4_system_failure = 'CH4_system_failure',
    CH4_battery_alarm = 'CH4_battery_alarm',
    CH4_eol_alarm = 'CH4_eol_alarm',
    offline = 'offline',
}

export enum AvoltaAlarmCategoryEnum {
    GAS_ALARM = 'GAS_ALARM',
    TROUBLE = 'TROUBLE',
}

/**
 * Avolta alarm configuration
 */
export interface AvoltaAlarm {
    name: AvoltaAlarmEnum;
    label: string;
    icon: string;
    short: string;
    color: string;
}